export default "__VITE_ASSET__a8e4bdfc__"